import React, { useState, useEffect } from "react";
import {
  Toolbar,
  Grid,
  Card,
  makeStyles,
  CardContent,
  Table,
  TableBody,
  TableRow,
  TableContainer,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import { emadateStatistic } from "shared/api/emandate";
import moment from "moment";

const TABLE_HEADER = {
  Date: "date",
  Created: "created_count",
  "Soft Failed": "soft_failed_count",
  Failed: "failed_count",
  Inactive: "inactive_count",
  Captured: "captured_count",
  Total: "total",
};

const style = makeStyles((theme) => ({
  table: {
    marginBottom: "20px",
    "& tbody:nth-child(even)": {
      backgroundColor: Colors["lighterPurple"],
    },
  },
}));

const TableTitle = ({ title }) => {
  return <span className="common_title">{title}</span>;
};
const TableHeaderCell = ({ headerTitle }) => {
  return (
    <TableBodyCell className="common_table_title">{headerTitle}</TableBodyCell>
  );
};

const StatisticsRegistrationCard = (props) => {
  const classes = style();

  const { data, title } = props;
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TableTitle title={title} />
        <TableContainer className="common_X_scroll">
          <Table className={classes.table}>
            <TableBody>
              <TableRow>
                {Object.keys(TABLE_HEADER).map((header, idx) => (
                  <TableHeaderCell key={idx} headerTitle={header} />
                ))}
              </TableRow>
            </TableBody>
            {data?.map((item, index) => (
              <TableBody key={index}>
                <TableRow>
                  {Object.keys(TABLE_HEADER).map((header, idx) => (
                    <TableHeaderCell
                      key={idx}
                      headerTitle={item[TABLE_HEADER[header]] || "-"}
                    />
                  ))}
                </TableRow>
              </TableBody>
            ))}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

const StatisticsRegistration = (props) => {
  const classes = style();
  const [spinning, setSpinning] = useState(false);
  const [emadateStatisticData, setEmadateStatisticData] = useState(null);

  useEffect(() => {
    statisticsRegistration();
  }, []);

  const fetchData = async (date) => {
    try {
      setSpinning(true);
      let formattedDate = moment(date).format("YYYY-MM-DD");
      const response = await emadateStatistic(formattedDate);
      if (response?.hasOwnProperty("success") && response?.success) {
        const { data } = response;
        setEmadateStatisticData(data?.emandate);
        setSpinning(false);
      }
    } catch (error) {
      setSpinning(false);
    }
  };

  const statisticsRegistration = async () => {
    let todayDate = new Date();
    fetchData(todayDate);
  };
  const { open } = props;
  return (
    <>
      <Header open={open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={10}>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <BreadcrumbsHeader text="Statistics Registration" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </Header>
      <div className="common_padding_from_title"></div>
      <Card
        style={{ boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}` }}
        className={classes.card}
      >
        <CardContent className="disburse_statistic_content p-1">
          <Grid container>
            <Grid item lg={9} md={9} sm={12} xs={12}>
              <Grid item xs={12}>
                <CardContent>
                  {spinning ? (
                    "Loading..."
                  ) : (
                    <>
                     <StatisticsRegistrationCard
                        title="emandate registration statistics"
                        data={
                          emadateStatisticData?.emandate_registration_statistics
                        }
                      />
                      <StatisticsRegistrationCard
                        title="Debit Card Registrations"
                        data={
                          emadateStatisticData?.debit_card_user_registration_statistics
                        }
                      />
                      <StatisticsRegistrationCard
                        title="Net Banking Registrations"
                        data={
                          emadateStatisticData?.netbanking_user_registration_statistics
                        }
                      />
                    </>
                  )}
                </CardContent>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
export default StatisticsRegistration;
